export const COMPANY_NAME = "NDR";
export const COMPANY_TAGLINE =
  "Trusted Transport and Logistics Partner in Europe and the UK";
export const COMPANY_CONTACT = {
  phone: "+436601827658",
  email: "ndexpresslogistics@gmail.com",
  address: "Arad, Romania",
};
